// extracted by mini-css-extract-plugin
module.exports = {"bold":"Text_bold__3aheX","italic":"Text_italic__cJDlb","underline":"Text_underline__Ep6_0","strikethrough":"Text_strikethrough__eXIjM"};